import { useState } from 'react';
import { Background } from 'shared/constants/backgrounds';
import { theme } from 'styles/theme/theme';
import { UDButton, UDText } from 'ud-ui/components';
import { BackgroundItem } from './background-item';
import { BackgroundList, Buttons, Layout } from './styles';

interface BackgroundPickerProps {
  img?: string;
  backgrounds: Background[];
  current?: Background;
  onApply: (background: Background) => void;
  onCancel: () => void;
}

/** Выбор фона под логотип: то же изображение показывается на каждом варианте. */
export function BackgroundPicker({ img, backgrounds, current, onApply, onCancel }: BackgroundPickerProps) {
  const [selected, setSelected] = useState<Background>(current ?? backgrounds[0]);

  return (
    <Layout>
      <div>
        <UDText type="footnote">Укажите фон для вашего логотипа</UDText>
        <BackgroundList>
          {backgrounds.map((background) => (
            <BackgroundItem
              key={background.value}
              background={background}
              img={img}
              isActive={background.value === selected?.value}
              hoverable
              onClick={() => setSelected(background)}
            />
          ))}
        </BackgroundList>
      </div>

      <UDText type="tip" color={theme.colors.SurfaceRomanSilver30}>
        *обратите внимание на цвет фона, он не должен сливаться с основными цветом вашего изображения
      </UDText>

      <Buttons>
        <UDButton style={{ height: 36, width: 130 }} type="button" variant="primary" onClick={() => onApply(selected)}>
          Применить
        </UDButton>
        <UDButton style={{ height: 36, width: 130 }} type="button" variant="gray" onClick={onCancel}>
          Отмена
        </UDButton>
      </Buttons>
    </Layout>
  );
}
